import { Injectable, Inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Observable, Observer } from 'rxjs';
import moment from 'moment';
import { tap } from 'rxjs/operators';
import { IUserRole } from './IUserRole';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  private uri = `${environment.apiLocation}/UserRole`;
  public roles$: Observable<Array<IUserRole>> = new Observable<Array<IUserRole>>(
    o => (this._observer = o)
  );
  constructor(
    @Inject(HttpClient) private http: HttpClient,
    @Inject(LoggingService) private log: LoggingService
  ) { }

  private _observer: Observer<Array<IUserRole>>;

  public getUserRoles (): Observable<Array<IUserRole>> {
    return this.http
      .get<Array<IUserRole>>(this.uri)
      .pipe(
        tap(data => this.log.verbose({ type: 'UserRoleService:getUserRoles:reponse', data }))
      );
  }
}
